import { render } from "./Channel.vue?vue&type=template&id=615e7fbe&scoped=true"
import script from "./Channel.vue?vue&type=script&lang=js"
export * from "./Channel.vue?vue&type=script&lang=js"

import "./Channel.vue?vue&type=style&index=0&id=615e7fbe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615e7fbe"]])

export default __exports__